// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LangIndexRouteImport } from './routes/$lang.index'
import { Route as LangSlugRouteImport } from './routes/$lang.$slug'
import { Route as AuthenticatedPainelRouteImport } from './routes/_authenticated/painel'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const LangIndexRoute = LangIndexRouteImport.update({
            id: '/$lang/',path: '/$lang/',getParentRoute: () => rootRouteImport
          })
const LangSlugRoute = LangSlugRouteImport.update({
            id: '/$lang/$slug',path: '/$lang/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedPainelRoute = AuthenticatedPainelRouteImport.update({
            id: '/painel',path: '/painel',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedPainelRoute: AuthenticatedPainelRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,ResetPasswordRoute: ResetPasswordRoute,LangSlugRoute: LangSlugRoute,LangIndexRoute: LangIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)